import React, { Component } from "react";
import { Header } from "semantic-ui-react";
import { OverridableContext } from "react-overridable";
import history from "@history";
import { SearchControlsOverridesMap } from "@modules/SearchControls/SearchControlsOverrides";
import { SearchControls } from "@modules/SearchControls/SearchControls";
import SearchFooter from "@modules/SearchControls/SearchFooter";
import { documentApi } from "@api/documents";
import { Media } from "@components/Media";
import { DocumentSubjectGrid } from "@modules/Document/DocumentSubjectLayout";

import {
  InvenioSearchApi,
  ReactSearchKit,
  ResultsLoader,
  Error,
  ResultsGrid,
} from "react-searchkit";

import {
  setReactSearchKitInitialQueryState,
  setReactSearchKitDefaultSortingOnEmptyQueryString,
  setReactSearchKitUrlHandler,
} from "@config";

export class SuggestedRelatedMaterials extends Component {
  modelName = "DOCUMENTS";

  render() {
    const api = new InvenioSearchApi({
      axios: {
        url: documentApi.searchBaseURL,
        withCredentials: true,
      },
    });

    const initialQueryState = setReactSearchKitInitialQueryState(
      this.modelName
    );
    const defaultSortingOnEmptyQueryString =
      setReactSearchKitDefaultSortingOnEmptyQueryString(this.modelName);
    const urlHandler = setReactSearchKitUrlHandler(this.modelName, false);

    return (
      <>
        <Header as="h2" textAlign="center">
          You may be interested in
        </Header>
        <OverridableContext.Provider
          value={{
            ...SearchControlsOverridesMap,
            ResultsGrid: DocumentSubjectGrid,
          }}
        >
          <ReactSearchKit
            searchApi={api}
            history={history}
            urlHandlerApi={urlHandler}
            initialQueryState={initialQueryState}
            defaultSortingOnEmptyQueryString={defaultSortingOnEmptyQueryString}
          >
            <>
              <Media greaterThanOrEqual="computer">
                <ResultsLoader>
                  <Error />
                  <SearchControls
                    modelName={this.modelName}
                    withLayoutSwitcher={false}
                  />
                  <ResultsGrid />
                  <SearchFooter />
                </ResultsLoader>
              </Media>
              <Media lessThan="computer">
                <ResultsLoader>
                  <ResultsGrid overridableId="documents_suggestions_mobile" />
                </ResultsLoader>
              </Media>
            </>
          </ReactSearchKit>
        </OverridableContext.Provider>
      </>
    );
  }
}

SuggestedRelatedMaterials.propTypes = {};
